import {
  offAutocompleteComponents,
  INPUT_TAG_NAME,
  ElHasInputComponents,
  INPUT_COMPONENTS,
  AUTO_COMPLATE_OPEN_PARAMS,
  AUTO_COMPLATE_CLOSE_PARAMS,
  AutocomplateInputModeMap
} from './config'

import { getComponentName, getCurrentRouteInfo } from './utils'
import { getAutocompleteDomConfig } from './autocomplete-dom'

// 获取当前 el-input 的示例, 如不是el-input 返回 null
const getElInputComponent = (el) => {
  const isInput = el.tagName === INPUT_TAG_NAME
  const parentVue = (el.parentNode && el.parentNode.__vue__) || el.parentNode.parentNode.__vue__
  const componentName = getComponentName(parentVue)
  if (isInput && INPUT_COMPONENTS[componentName]) {
    return parentVue
  } else {
    return null
  }
}

// AutocomplateInput逻辑模式
const setAutocomplateInputMode = (el, mode, componentsType) => {
  if (!el._erpInputAutoCompleteConfig) {
    el._erpInputAutoCompleteConfig = {}
  }
  el._erpInputAutoCompleteConfig.mode = mode
  el._erpInputAutoCompleteConfig.componentsType = componentsType
}

// 是否是需要联想输入框
export const isAutocomplateInput = (el, options = {}) => {
  if (el.tagName === INPUT_TAG_NAME && ['text', 'number'].includes(el.type)) {
    const ElInput = getElInputComponent(el)
    if (ElInput) {
      let parent = ElInput

      while (parent) {
        const componentName = getComponentName(parent)
        const { blacklist = [] } = options
        // 关闭使用了input/el-input的组件不需要联想的组件
        if (offAutocompleteComponents.includes(componentName) || blacklist.includes(componentName)) {
          // 关于el-inputAutoComlate需要支持的逻辑
          if (ElHasInputComponents.ElAutocomplete === componentName) {
            const { triggerOnFocus } = parent.$props
            if (triggerOnFocus === false && parent.suggestionVisible === false) {
              setAutocomplateInputMode(el, AutocomplateInputModeMap.autocomplate, ElHasInputComponents.ElAutocomplete)
              return true
            }
          }
          // el-select 的 远程搜索组件
          if (ElHasInputComponents.ElSelect === componentName) {
            const { remote } = parent.$props
            if (remote === true) {
              setAutocomplateInputMode(el, AutocomplateInputModeMap.autocomplate, ElHasInputComponents.ElSelect)
              return true
            }
          }

          return false
        } else {
          parent = parent.$parent
        }
      }
      return true
    } else {
      // 原生输入框
      return true
    }
  }
  return false
}

// 是否开启了联想特性
export const isOpenAutocomplate = (el) => {
  // 日期内的input不要
  if (el.placeholder && /日期|时间/.test(el.placeholder)) return false
  while (el && el.tagName !== 'HTML') {
    const { inputAutocomplete } = getAutocompleteDomConfig(el)
    // 表格内的元素也不要
    if (el.className && /el-table|kye-table-v2__root/.test(el.className)) return false
    if (inputAutocomplete && [...AUTO_COMPLATE_OPEN_PARAMS, ...AUTO_COMPLATE_CLOSE_PARAMS].includes(inputAutocomplete)) {
      return AUTO_COMPLATE_OPEN_PARAMS.includes(inputAutocomplete)
    } else {
      // 目的：可配置所有子级不支持联想特性
      el = el.parentNode
    }
  }
  return true
}

// 判断路由是否关闭
export const routeAutocompleteStatus = (_, options = {}) => {
  const { whitelistRouter = [] } = options
  const { meta, path } = getCurrentRouteInfo()
  // 成产环境只有在白名单的路由才开启
  const isWhitelisting = whitelistRouter.length && whitelistRouter.some(i => path.indexOf(i) !== -1)
  if (AUTO_COMPLATE_CLOSE_PARAMS.includes(meta.inputAutocomplete)) {
    return false
  }
  if (!isWhitelisting) {
    return false
  }
  return true
}


export const checkInputStatus = (el) => {
  const isDisabled = el.disabled
  const isReadonly = el.readOnly
  const isCheckboxType = ['checkbox', 'number'].includes(el.type)
  if (isDisabled || isReadonly || isCheckboxType) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/input-check.js